import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { LicenseInfo } from "@mui/x-license";
import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, useRoutes } from "react-router";
import { Loader } from "./components/loader.tsx";
import { config } from "./config/index.ts";
import { AlertProvider } from "./context/AlertContext.tsx";
import { GlobalErrorBoundary } from "./GlobalErrorBoundary.tsx";
import "./lib/api/setupInterceptors"; // Initialize API interceptors
import { ObservabilityProvider } from "./lib/observability/hooks.tsx";
import { observability } from "./lib/observability/index.ts";
import { QueryClientProvider, queryClient, ReactQueryDevtools } from "./lib/react-query/index.ts";
import { AuthProvider } from "./providers/authProvider/index.tsx";
import { routes } from "./routes.tsx";
import { figma } from "./themes/figma/figma.ts";

// Initialize MUI X license
LicenseInfo.setLicenseKey(config.dataGridPro.licenseKey);

const { apm } = observability.start(config.ilEnv);

function AppRoutes() {
  return <Suspense fallback={<Loader />}>{useRoutes(routes)}</Suspense>;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider theme={figma} forceThemeRerender>
      <CssBaseline />
      <ObservabilityProvider apm={apm}>
        <GlobalErrorBoundary apm={apm}>
          <AlertProvider>
            <QueryClientProvider client={queryClient}>
              <ReactQueryDevtools initialIsOpen={false} />
              <BrowserRouter>
                <AuthProvider>
                  <AppRoutes />
                </AuthProvider>
              </BrowserRouter>
            </QueryClientProvider>
          </AlertProvider>
        </GlobalErrorBoundary>
      </ObservabilityProvider>
    </ThemeProvider>
  </StrictMode>,
);
